import { bannerManager } from '@envato/foundation-types'
import axiosVerbose from '../../utils/axios/axiosVerbose'
import { logError } from '../../utils/errors'
import { hasFeature } from '../../utils/features'
import { ICommonLocation } from '../../utils/location/types'

import { ThunkAction } from 'redux-thunk'

export enum TypeKeys {
  GET_BANNER_SUCCESS = 'GET_BANNER_SUCCESS',
  GET_BANNER_FAIL = 'GET_BANNER_FAIL'
}

export interface IGetBannerSuccessAction {
  type: TypeKeys.GET_BANNER_SUCCESS
  payload: bannerManager.headerBanners.IResult
}

export interface IGetBannerFailAction {
  type: TypeKeys.GET_BANNER_FAIL
}

export type ActionTypes = IGetBannerSuccessAction | IGetBannerFailAction

export const fetchBannerDataBySite = ({
  apiUrlPrefix,
  apiAppUrlPrefix,
  location
}: {
  apiUrlPrefix: string
  apiAppUrlPrefix: string
  location: ICommonLocation
}): ThunkAction<any, any, any> => {
  return (dispatch, getState) => {
    const query = location.query
    const { currentSite } = getState().common
    let prefix = `${apiUrlPrefix}/shopfront_api`
    if (hasFeature('shopfront-api', currentSite, location)) {
      prefix = `${apiAppUrlPrefix}/shopfront-api`
    }
    const apiUrl = `${prefix}/banner/${currentSite}`
    return axiosVerbose
      .get<bannerManager.headerBanners.IResult>(apiUrl)
      .then(response => {
        const successAction: IGetBannerSuccessAction = {
          payload: response.data,
          type: TypeKeys.GET_BANNER_SUCCESS
        }
        return dispatch(successAction)
      })
      .catch(err => Promise.reject(logError(err)))
      .catch(() => {
        // if banner data fetch error, we simply report to rollbar
        // and don't do anything
        return dispatch({
          type: TypeKeys.GET_BANNER_FAIL
        })
      })
  }
}
